import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
// import StarIcon from '@mui/icons-material/Star';
import {
  Box,
  Button,
  DialogActions,
  Stack,
  // List,
  // ListItem,
  // ListItemText,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ExitPopupBOIR = () => {
  const [open, setOpen] = useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="holiday-theme"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 3 }}
            alignItems="center"
            justifyContent="space-around"
            sx={{ px: { xs: 0, sm: 2 }, mb: 1 }}
          >
            <Box
              component="img"
              src="/assets/images/clock-icon.png"
              loading="lazy"
              alt="Wait! Before you leave…"
              width={100}
              height={115}
            />

            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, md: 26 },
                  color: '#da4b4b',
                }}
              >
                Don&apos;t miss out on 10% off!
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: 19, sm: 22, md: 22 },
                  mb: 0,
                  lineHeight: 1.3,
                }}
              >
                Use code <strong>TZOBOIR10</strong> at checkout!
              </Typography>
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{}}
          >
            <Box
              component="ul"
              sx={{ listStyleType: 'none', pl: { xs: 4, sm: 2 }, mb: 1 }}
            >
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'center',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                TaxZerone simplifies e-filing&nbsp;<b>BOI</b>&nbsp;for all
                business owners.
              </Box>
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'flex-start',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                File your BOI report for&nbsp;
                <b style={{ color: '#2a525a' }}>just $39.99 per EIN</b>.
              </Box>
              <Box
                component="li"
                sx={{
                  display: { xs: 'inline-block', sm: 'flex' },
                  alignItems: 'center',
                  mb: 1.25,
                  textIndent: { xs: '-30px', sm: 0 },
                  textAlign: 'left',
                }}
              >
                <CheckCircleRoundedIcon
                  sx={{
                    mr: 1,
                    color: '#1da94a',
                    mb: { xs: -0.8, sm: 0 },
                  }}
                />
                Get&nbsp;<b style={{ color: '#af8f38' }}>FREE record-keeping</b>
                &nbsp;with your BOI report filing!
              </Box>
            </Box>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: '24px !important',
          textAlign: 'center',
          backgroundColor: '#f9f9f9',
          borderTop: '1px solid #ccc',
        }}
      >
        <Box sx={{ px: { xs: 1, sm: 3 }, mt: 1 }}>
          <Typography
            variant="body1"
            sx={{ fontSzie: 16, fontWeight: 500, mb: 1 }}
          >
            Make <b>BOI report</b> filing easy—Choose TaxZerone!
          </Typography>
          <Button
            variant="contained"
            size="large"
            // className="btn-primary"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 4,
              display: 'inline-block',
              fontSize: { xs: 18, sm: 20, md: 22, lg: 24 },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
          >
            File BOI Report Now!
          </Button>
        </Box>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ExitPopupBOIR;
